import { render, staticRenderFns } from "./DetailConfigDatasetEdit.vue?vue&type=template&id=701a9bd1"
import script from "./DetailConfigDatasetEdit.vue?vue&type=script&lang=js"
export * from "./DetailConfigDatasetEdit.vue?vue&type=script&lang=js"
import style0 from "./DetailConfigDatasetEdit.vue?vue&type=style&index=0&id=701a9bd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports